import { IMAGES } from "@/data/content";

export const LEXICON = [
  { plain: "Customers", coded: "Initiates" },
  { plain: "Products", coded: "Relics" },
  { plain: "Mentors", coded: "Oracles" },
  { plain: "Members-only events", coded: "Mysteries" },
  { plain: "The Mastermind", coded: "The Inner Sanctum" },
];

export const OATH_LINES = [
  "I come to the Sanctum not to be seen, but to remember.",
  "I vow silence upon the workings of the Inner Sanctum —",
  "its names, its rites, its capital, its women.",
  "I will not compete against my sisters in the circle;",
  "I will pool what I hold and protect what they carry.",
  "I renounce the hustle that hollowed my mothers.",
  "I lead from the root. I rise from the lineage.",
  "What is entrusted to me, I hold for the daughters unborn.",
  "This I seal — not in ink, but in blood-intention.",
];

export const NDA = {
  title: "Covenant of Silence",
  subtitle: "Non-Disclosure Agreement of the Inner Sanctum",
  preamble:
    "By sealing this Covenant, you (the “Initiate”) enter into a binding agreement of confidentiality with Sybils Society and every woman within its circle (the “Society”). This agreement takes effect the moment you seal it and endures in perpetuity.",
  clauses: [
    {
      heading: "I. Confidential Matter",
      body: "All that passes within the Inner Sanctum is Confidential Matter — the identities and lineages of members, the rites and teachings, the capital pooled and its movements, the proceedings of the Council, and any writing, recording, or relic entrusted to you.",
    },
    {
      heading: "II. The Vow of Silence",
      body: "You shall not disclose, publish, reproduce, or repeat any Confidential Matter to any person outside the circle, by any means, spoken or written, encrypted or plain — nor confirm nor deny the membership of another.",
    },
    {
      heading: "III. Sole Purpose",
      body: "Confidential Matter is entrusted to you solely for your work within the Society. You shall not use it for personal gain, competitive advantage, or the benefit of any outside party.",
    },
    {
      heading: "IV. No Competition Against the Circle",
      body: "You shall not weaponise what you learn here against a sister of the circle, nor solicit the Society’s members, ventures, or capital for ends the Council has not sanctioned.",
    },
    {
      heading: "V. Return & Erasure",
      body: "Should your passage end, you shall return or destroy every relic and record in your keeping, and the Vow of Silence shall remain unbroken thereafter.",
    },
    {
      heading: "VI. Consequence",
      body: "A breach dissolves your standing at once and empowers the Society to pursue every remedy the seen and unseen worlds allow. What is sealed here cannot be unspoken.",
    },
  ],
  acknowledgement:
    "I have read and understood this Covenant of Silence, and I bind myself to it freely and in perpetuity.",
};

export const RELICS = [
  {
    id: "codex",
    name: "The Codex of Ruled Time",
    was: "The Chronos Journal",
    image: "chronos",
    lore: "A restricted-run volume that refuses the Gregorian grid. Time is tracked by lunar cycles and personal energetic pattern. Bound within: private sigils for manifestation.",
    tier: "The Novitiate",
  },
  {
    id: "scrying",
    name: "The Governance Scrying Kit",
    was: "Oracle Decks",
    image: "oracleDeck",
    lore: "Not divination alone, but strategy. Initiates are taught specific spreads to read the political and economic landscape before any major move.",
    tier: "The Adept",
  },
  {
    id: "sacraments",
    name: "The Alchemical Sacraments",
    was: "Apothecary & Fragrance",
    image: "apothecary",
    lore: "Elixirs and scents formulated to alter consciousness for deep ancestral work. Released only to those who have completed the first tier of study.",
    tier: "The Adept",
  },
];

export const MYSTERIES = [
  {
    tier: "Tier I",
    name: "The Novitiate",
    subtitle: "The Awakening",
    body: "Entry by the Sybils Assessment — a rigorous reckoning of emotional intelligence, ethical standing, and vision for legacy. Not everyone is accepted. The accepted receive a sealed vial and the Codex of Ruled Time.",
    image: "ruler",
  },
  {
    tier: "Tier II",
    name: "The Adept",
    subtitle: "The Work",
    body: "Private Audience with the Oracle — strategic council where lineage is read and blocked power unlocked. And the Matriarchal Mysteries: bi-annual gatherings whose locations are revealed 48 hours prior.",
    image: "creator",
  },
  {
    tier: "Tier III",
    name: "The Matriarch",
    subtitle: "The Legacy",
    body: "The Inner Sanctum. Members must prove they are actively dismantling patriarchal systems in their field. Here capital is pooled for matriarchal investment and political lobbying.",
    image: "chronos",
  },
];

export { IMAGES };
